(function () {
    'use strict';

    angular.module("imApp").factory("srResourceService", ['$ihttp', function ($ihttp) {
        var service = {
            getSrResource: function (parms) {
                return $ihttp.post({
                    method: 2150,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2151,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();